import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.includeAvatar}}
  <div class="user-image">
    <div class="user-image-inner">
      <a
        href={{this.userPath}}
        data-user-card={{@user.username}}
        aria-hidden="true"
      >{{avatar @user imageSize="large"}}</a>
      <UserAvatarFlair @user={{@user}} />
    </div>
  </div>
{{/if}}
<div class="user-detail">
  <div class="name-line">
    {{#if this.includeLink}}
      <a href={{this.userPath}} data-user-card={{@user.username}}>
        <span class={{if this.nameFirst "name" "username"}}>
          {{if this.nameFirst @user.name (format-username @user.username)}}
        </span>
        <span class={{if this.nameFirst "username" "name"}}>
          {{if this.nameFirst (format-username @user.username) @user.name}}
        </span>
      </a>
    {{else}}
      <span class={{if this.nameFirst "name" "username"}}>
        {{if this.nameFirst @user.name (format-username @user.username)}}
      </span>
      <span class={{if this.nameFirst "username" "name"}}>
        {{if this.nameFirst (format-username @user.username) @user.name}}
      </span>
    {{/if}}
    {{#if (and @showStatus @user.status)}}
      <UserStatusMessage
        @status={{@user.status}}
        @showDescription={{@showStatusDescription}}
      />
    {{/if}}
    <PluginOutlet
      @name="after-user-name"
      @connectorTagName="span"
      @outletArgs={{hash user=this.user}}
    />
  </div>
  <div class="title">{{@user.title}}</div>
  {{#if (has-block)}}
    <div class="details">
      {{yield}}
    </div>
  {{/if}}
</div>

<PluginOutlet
  @name="after-user-info"
  @connectorTagName="div"
  @outletArgs={{hash user=this.user}}
/>
*/
{
  "id": "LJwLG5Qn",
  "block": "[[[41,[30,0,[\"includeAvatar\"]],[[[1,\"  \"],[10,0],[14,0,\"user-image\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"user-image-inner\"],[12],[1,\"\\n      \"],[10,3],[15,6,[30,0,[\"userPath\"]]],[15,\"data-user-card\",[30,1,[\"username\"]]],[14,\"aria-hidden\",\"true\"],[12],[1,[28,[35,1],[[30,1]],[[\"imageSize\"],[\"large\"]]]],[13],[1,\"\\n      \"],[8,[39,2],null,[[\"@user\"],[[30,1]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[10,0],[14,0,\"user-detail\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"name-line\"],[12],[1,\"\\n\"],[41,[30,0,[\"includeLink\"]],[[[1,\"      \"],[10,3],[15,6,[30,0,[\"userPath\"]]],[15,\"data-user-card\",[30,1,[\"username\"]]],[12],[1,\"\\n        \"],[10,1],[15,0,[52,[30,0,[\"nameFirst\"]],\"name\",\"username\"]],[12],[1,\"\\n          \"],[1,[52,[30,0,[\"nameFirst\"]],[30,1,[\"name\"]],[28,[37,3],[[30,1,[\"username\"]]],null]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[15,0,[52,[30,0,[\"nameFirst\"]],\"username\",\"name\"]],[12],[1,\"\\n          \"],[1,[52,[30,0,[\"nameFirst\"]],[28,[37,3],[[30,1,[\"username\"]]],null],[30,1,[\"name\"]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[15,0,[52,[30,0,[\"nameFirst\"]],\"name\",\"username\"]],[12],[1,\"\\n        \"],[1,[52,[30,0,[\"nameFirst\"]],[30,1,[\"name\"]],[28,[37,3],[[30,1,[\"username\"]]],null]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[15,0,[52,[30,0,[\"nameFirst\"]],\"username\",\"name\"]],[12],[1,\"\\n        \"],[1,[52,[30,0,[\"nameFirst\"]],[28,[37,3],[[30,1,[\"username\"]]],null],[30,1,[\"name\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[41,[28,[37,4],[[30,2],[30,1,[\"status\"]]],null],[[[1,\"      \"],[8,[39,5],null,[[\"@status\",\"@showDescription\"],[[30,1,[\"status\"]],[30,3]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[8,[39,6],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"after-user-name\",\"span\",[28,[37,7],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"title\"],[12],[1,[30,1,[\"title\"]]],[13],[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"    \"],[10,0],[14,0,\"details\"],[12],[1,\"\\n      \"],[18,4,null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[8,[39,6],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"after-user-info\",\"div\",[28,[37,7],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null]],[\"@user\",\"@showStatus\",\"@showStatusDescription\",\"&default\"],false,[\"if\",\"avatar\",\"user-avatar-flair\",\"format-username\",\"and\",\"user-status-message\",\"plugin-outlet\",\"hash\",\"has-block\",\"yield\"]]",
  "moduleName": "discourse/components/user-info.hbs",
  "isStrictMode": false
});